import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// import { AuthGuardService } from '../_services';

//Components...
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
    data: {
      layoutName: "layoutTwo"
    },
    // canActivate: [AuthGuardService]
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    data: {
      layoutName: "layoutTwo"
    },
    // canActivate: [AuthGuardService]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
